import type { Configuration } from "@azure/msal-browser";
import { LogLevel } from "@azure/msal-browser";

export const msalConfig: Configuration = {
    auth: {
        clientId: import.meta.env.VITE_AZURE_CLIENT_ID || "",
        authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || ""}`,
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "sessionStorage",
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
            logLevel: LogLevel.Info,
        },
    },
};

export const loginRequest = {
    scopes: ["openid", "profile", "User.Read"]
};

export const apiRequest = {
    // TODO: Update with your API scope for feature-feedback API
    scopes: [
        `api://${import.meta.env.VITE_AZURE_CLIENT_ID}/Account.Read`, 
        `api://${import.meta.env.VITE_AZURE_CLIENT_ID}/Account.Edit`, 
        `api://${import.meta.env.VITE_AZURE_CLIENT_ID}/Feedback.Read`],
};
